import React from "react";
import { styled } from "@mui/system";
import MUIStepButton from "@mui/material/StepButton";
import { StepButtonProps as StepButtonPropsMUI } from "@mui/material/StepButton";
import {
  ExtendButtonBase,
  ExtendButtonBaseTypeMap
} from "@mui/material/ButtonBase";
export interface StepButtonProps extends StepButtonPropsMUI {}

const StepButtonRoot = styled(MUIStepButton, {
  name: "StepButton",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({}));

export type StepButtonTypeMap<
  AdditionalProps,
  RootComponent extends React.ElementType
> = ExtendButtonBaseTypeMap<{
  props: AdditionalProps & StepButtonProps;
  defaultComponent: RootComponent;
  ignoredProps: "disabled";
}>;

export const StepButton = React.forwardRef<HTMLButtonElement, StepButtonProps>(
  function StepButton(props, ref) {
    return <StepButtonRoot {...props} ref={ref} />;
  }
) as ExtendButtonBase<StepButtonTypeMap<{}, "button">>;
